"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialValues = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _settingsWrapper = _interopRequireDefault(require("../../../../helpers/settingsWrapper"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var initialValues = {
  showTitleInTooltip: true,
  mustTakeInOrder: true
};
exports.initialValues = initialValues;
var Settings = function Settings() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].toggleGroup
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "showTitleInTooltip",
    component: _cccisdFormik.CccisdToggle,
    label: "Show survey title in tooltip"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "mustTakeInOrder",
    component: _cccisdFormik.CccisdToggle,
    label: "User must take surveys in order"
  }));
};
var _default = (0, _settingsWrapper["default"])({
  initialValues: initialValues
})(Settings);
exports["default"] = _default;